import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData) => {
  const data = fetchData;
  // console.log("checking data in product", fetchData);

  const formattedData = useMemo(() => {
    const rows = [];

    if (data && Array.isArray(data)) {
      data.forEach((order, index) => {
        // console.log("order", order);

        // Map data to the desired format
        const row = {
          id: index,
          product_id: order.product_id || "",
          product_code: order.product_code || "", // Provide default value
          product_name: order.product_name || "", // Provide default value
          category_id: order.category_id || "", // Provide default value
          detail: order.detail || "", // Provide default value
          blemishes: order.blemishes || "", // Provide default value
          size: order.size || "", // Provide default value
          total_amount: order.total_amount || 0, // Provide default value
          created_by: order.created_by || "", // Provide default value
          updated_by: order.updated_by || "", // Provide default value
          barcode: order.barcode || "", // Provide default value
          price: order.price || 0, // Provide default value
          total_price: order.total_price || 0, // Provide default value
          product_type: order.product_type || "", // Provide default value
          is_active: order.is_active || false, // Provide default value
          notes: order.notes || "", // Provide default value
          sell_price: order.sell_price,
          created_date: order.created_date
            ? moment(order.created_date).format("DD/MM/YYYY\n เวลา HH:mm:ss น.")
            : "",
          updated_date: order.updated_date
            ? moment(order.updated_date).format("DD/MM/YYYY\n เวลา HH:mm:ss น.")
            : "",
          picture: (order.Pictures || []).map((picture) => ({
            id: picture.id || "", // Provide default value
            picture: picture.pic
              ? picture.pic
                  .split("http")
                  .filter(Boolean)
                  .map((url) => `http${url.trim()}`)
              : [], // Provide default value
          })),
          customer_name: order.Customer?.name || "", // Provide default value
          customer_id: order.Customer?.customer_id || "", // Provide default value
          idcard: order.Customer?.idcard || "", // Provide default value
          customer_phonenumber: order.Customer?.phonenumber || "", // Provide default value
        };

        rows.push(row);
      });
    }

    return rows;
  }, [data]);

  return formattedData;
};

export default useProductData;
